(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shipshop-pink-hero"] && !Shopify.designMode) return;
  try {
    
  if (!window.shipshopPinkHeroReady) {
    window.shipshopPinkHeroReady = true;
    const updateWheelLinks = () => {
      const parts = new Intl.DateTimeFormat('en', { timeZone:'Asia/Jerusalem', year:'numeric', month:'2-digit' }).formatToParts(new Date());
      const available = parts.find(part => part.type === 'year').value === '2026' && parts.find(part => part.type === 'month').value === '10';
      document.querySelectorAll('[data-shipshop-wheelio-open]').forEach(element => { element.hidden = !available; });
    };
    const initializeWheelLinks = () => {
      updateWheelLinks();
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeWheelLinks, { once:true });
    else initializeWheelLinks();
    document.addEventListener('shopify:section:load', initializeWheelLinks);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shipshop-pink-wheel"] && !Shopify.designMode) return;
  try {
    
(() => {
  const ids = ['spend1000', 'spend500', 'percent10', 'mystery'];
  const weights = [10, 20, 50, 20];
  const bounds = [[0, 36], [36, 108], [108, 288], [288, 360]];
  const minimums = Object.freeze({ spend1000: 100000, spend500: 50000, percent10: 20000, mystery: 20000 });
  const initialState = () => ({ attempts: 0, finalized: false, rewardId: null, bonusWon: false, redeemPath: null, couponCode: null, issuedAt: null, expiresAt: null });
  const couponLifetime = 24 * 60 * 60 * 1000;
  function integer(limit) {
    const ceiling = Math.floor(4294967296 / limit) * limit;
    const value = new Uint32Array(1);
    do { crypto.getRandomValues(value); } while (value[0] >= ceiling);
    return value[0] % limit;
  }
  function rewardForBucket(bucket) {
    if (!Number.isInteger(bucket) || bucket < 0 || bucket > 99) throw new RangeError('Invalid reward bucket');
    if (bucket < 10) return 0;
    if (bucket < 30) return 1;
    if (bucket < 80) return 2;
    return 3;
  }
  function eligibleForReward(id, subtotal) {
    if (!Number.isInteger(subtotal) || subtotal < 0) throw new RangeError('Invalid subtotal');
    if (!Object.hasOwn(minimums, id)) throw new RangeError('Invalid reward');
    return subtotal >= minimums[id];
  }
  function payableCents(id, subtotal) {
    if (!eligibleForReward(id, subtotal)) return subtotal;
    if (id === 'spend1000') return subtotal - 20000;
    if (id === 'spend500') return subtotal - 7500;
    if (id === 'percent10') return subtotal - Math.min(5000, Math.round(subtotal / 10));
    return subtotal;
  }
  function normalizeEmail(value) {
    const email = String(value).trim().toLowerCase();
    return email.length <= 254 && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email) ? email : null;
  }
  function validState(value) {
    if (!value || !Number.isInteger(value.attempts) || value.attempts < 0 || value.attempts > 1 || typeof value.finalized !== 'boolean' || value.bonusWon !== false) throw new Error('Invalid campaign state');
    if (value.attempts === 0 && (value.rewardId != null || value.finalized || value.bonusWon)) throw new Error('Invalid initial state');
    if (value.attempts > 0 && !ids.includes(value.rewardId)) throw new Error('Invalid reward');
    if (value.attempts === 1 && !value.finalized) throw new Error('Final attempt must be final');
    if (value.couponCode != null) {
      if (!value.finalized || typeof value.couponCode !== 'string' || !/^[A-Za-z0-9_-]{3,64}$/.test(value.couponCode)) throw new Error('Invalid coupon');
      const issued = Date.parse(value.issuedAt), expires = Date.parse(value.expiresAt);
      if (typeof value.issuedAt !== 'string' || typeof value.expiresAt !== 'string' || !Number.isFinite(issued) || !Number.isFinite(expires) || expires - issued !== couponLifetime) throw new Error('Invalid coupon lifetime');
    } else if (value.issuedAt != null || value.expiresAt != null || value.redeemPath != null) throw new Error('Coupon is missing');
    if (value.redeemPath != null && value.redeemPath !== '/discount/' + encodeURIComponent(value.couponCode) + '?redirect=%2Fcart') throw new Error('Invalid redemption');
    return { attempts: value.attempts, finalized: value.finalized, rewardId: value.rewardId || null, bonusWon: value.bonusWon, redeemPath: value.redeemPath || null, couponCode: value.couponCode || null, issuedAt: value.issuedAt || null, expiresAt: value.expiresAt || null };
  }
  window.ShipshopPinkWheelRules = Object.freeze({ rewardForBucket, payableCents, eligibleForReward, normalizeEmail, validState, minimums, weights: Object.freeze(weights), ids: Object.freeze(ids) });
  class ShipshopPinkWheel extends HTMLElement {
    connectedCallback() {
      if (this.ready) { this.clock = setInterval(() => { if (this.state.couponCode && this.dialog.open) this.renderCoupon(); }, 1000); return; }
      this.ready = true;
      this.preview = this.dataset.preview === 'true';
      this.rotation = 0;
      this.busy = false;
      this.identityReady = false;
      this.state = initialState();
      this.pending = new Map();
      this.copy = JSON.parse(this.querySelector('[data-copy]').textContent);
      this.dialog = this.querySelector('dialog');
      this.wheel = this.querySelector('.spw-wheel');
      this.spinButton = this.querySelector('[data-spin]');
      this.keepButton = this.querySelector('[data-keep]');
      this.emailForm = this.querySelector('[data-email-form]');
      this.setAttribute('dir', 'rtl');
      this.querySelector('[data-preview-label]').hidden = !this.preview;
      this.querySelector('[data-demo-note]').hidden = !this.preview;
      this.querySelector('.spw-impact').hidden = !this.preview;
      this.draw();
      this.querySelector('[data-open]').addEventListener('click', () => this.open());
      this.querySelector('[data-close]').addEventListener('click', () => this.dialog.close());
      this.dialog.addEventListener('click', event => {
        if (event.target !== this.dialog) return;
        const rect = this.dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.dialog.close();
      });
      this.spinButton.addEventListener('click', () => this.spin());
      this.keepButton.addEventListener('click', () => this.keep());
      this.emailForm.addEventListener('submit', event => { event.preventDefault(); this.spin(); });
      this.querySelector('[data-copy-coupon]').addEventListener('click', () => this.copyCoupon());
      this.querySelector('[data-redeem]').addEventListener('click', event => {
        if (this.preview || !this.state.redeemPath || Date.parse(this.state.expiresAt) <= Date.now()) { event.preventDefault(); this.render(); }
      });
      this.clock = setInterval(() => { if (this.state.couponCode && this.dialog.open) this.renderCoupon(); }, 1000);
      this.render();
    }
    disconnectedCallback() { clearInterval(this.clock); }
    open() {
      if (!this.dialog.open) this.dialog.showModal();
    }
    showError(message) {
      const error = this.querySelector('[data-error]');
      error.textContent = message;
      error.hidden = false;
      error.scrollIntoView({ behavior: 'instant', block: 'nearest' });
    }
    clearError() { this.querySelector('[data-error]').hidden = true; }
    friendlyError(error) { return Object.values(this.copy).includes(error.message) ? error.message : this.copy.error; }
    render() {
      const finished = this.state.finalized || this.state.attempts >= 1;
      this.emailForm.hidden = this.identityReady;
      this.spinButton.hidden = finished;
      this.spinButton.disabled = this.busy;
      if (!this.busy) this.spinButton.textContent = this.copy.spin;
      this.querySelector('[data-spin-note]').textContent = finished ? (this.state.couponCode ? this.copy.finalNote : this.copy.issuancePending) : this.copy.firstNote;
      this.keepButton.hidden = this.state.attempts === 0 || (finished && (this.preview || Boolean(this.state.redeemPath)));
      this.keepButton.disabled = this.busy;
      if (!this.busy) this.keepButton.textContent = finished ? this.copy.retryIssue : this.copy.keep;
      const result = this.querySelector('[data-result]');
      result.hidden = this.state.attempts === 0;
      if (this.state.attempts > 0) {
        const index = ids.indexOf(this.state.rewardId);
        this.querySelector('[data-result-eyebrow]').textContent = finished ? this.copy.finalTitle : this.copy.finalTitle;
        this.querySelector('[data-result-title]').textContent = this.copy['reward' + index];
        this.querySelector('[data-result-note]').textContent = this.copy['note' + index];
      }
      this.renderCoupon();
      this.querySelector('[data-email]').readOnly = this.identityReady;
    }
    renderCoupon() {
      const box = this.querySelector('[data-coupon]');
      const redeem = this.querySelector('[data-redeem]');
      const copyButton = this.querySelector('[data-copy-coupon]');
      box.hidden = !this.state.couponCode;
      const remaining = Date.parse(this.state.expiresAt) - Date.now();
      const active = Boolean(this.state.couponCode) && remaining > 0;
      if (this.state.finalized && this.state.couponCode) this.querySelector('[data-spin-note]').textContent = active ? this.copy.finalNote : this.copy.expired;
      redeem.hidden = !active || this.preview || !this.state.redeemPath;
      if (!redeem.hidden) redeem.setAttribute('href', this.state.redeemPath);
      else redeem.removeAttribute('href');
      if (box.hidden) return;
      this.querySelector('[data-coupon-code]').value = this.state.couponCode;
      this.querySelector('[data-coupon-label]').textContent = this.preview ? this.copy.demoCode : this.copy.codeLabel;
      copyButton.disabled = !active;
      copyButton.textContent = this.copiedCode === this.state.couponCode ? this.copy.copied : this.copy.copyCode;
      this.querySelector('[data-coupon-note]').textContent = active ? this.copy.couponNote : this.copy.expired;
      const expiry = this.querySelector('[data-coupon-expiry]');
      expiry.textContent = this.copy.expiresLabel + ' ' + new Intl.DateTimeFormat('ar', { timeZone: 'Asia/Jerusalem', dateStyle: 'short', timeStyle: 'short' }).format(new Date(this.state.expiresAt));
      expiry.setAttribute('datetime', this.state.expiresAt);
      const seconds = Math.max(0, Math.ceil(remaining / 1000));
      this.querySelector('[data-coupon-countdown]').textContent = active ? [Math.floor(seconds / 3600), Math.floor(seconds / 60) % 60, seconds % 60].map(number => String(number).padStart(2, '0')).join(':') : '00:00:00';
    }
    async copyCoupon() {
      if (!this.state.couponCode || Date.parse(this.state.expiresAt) <= Date.now()) return;
      try {
        await navigator.clipboard.writeText(this.state.couponCode);
        this.copiedCode = this.state.couponCode;
        this.renderCoupon();
      } catch {
        this.querySelector('[data-coupon-code]').focus();
        this.querySelector('[data-coupon-code]').select();
        this.showError(this.copy.copyError);
      }
    }
    draw() {
      const namespace = 'http://www.w3.org/2000/svg';
      const group = this.querySelector('[data-wheel-sectors]');
      const colors = ['#f9c8dc', '#e994b8', '#bd386d', '#892447'];
      const point = (angle, radius) => [200 + Math.sin(angle * Math.PI / 180) * radius, 200 - Math.cos(angle * Math.PI / 180) * radius];
      for (let i = 0; i < bounds.length; i++) {
        const [start, end] = bounds[i];
        const a = point(start, 195), b = point(end, 195);
        const path = document.createElementNS(namespace, 'path');
        path.setAttribute('d', `M 200 200 L ${a.join(' ')} A 195 195 0 0 1 ${b.join(' ')} Z`);
        path.setAttribute('fill', colors[i]);
        path.setAttribute('stroke', '#fff8fb');
        path.setAttribute('stroke-width', '2');
        group.append(path);
        const p = point((start + end) / 2, i === 0 ? 145 : i === 3 ? 139 : 121);
        const label = document.createElementNS(namespace, 'text');
        label.setAttribute('x', p[0]);
        label.setAttribute('y', p[1] - 4);
        label.setAttribute('text-anchor', 'middle');
        label.setAttribute('class', i === 3 ? 'spw-label-small' : `spw-label${i === 2 ? ' spw-label-white' : ''}`);
        label.setAttribute('direction', i < 3 ? 'ltr' : 'rtl');
        label.textContent = this.copy['wheel' + i];
        group.append(label);
        const sub = document.createElementNS(namespace, 'text');
        sub.setAttribute('x', p[0]);
        sub.setAttribute('y', p[1] + 15);
        sub.setAttribute('text-anchor', 'middle');
        sub.setAttribute('class', `spw-sub-label${i >= 2 ? ' spw-label-white' : ''}`);
        sub.setAttribute('fill', i >= 2 ? '#fff' : '#67233e');
        sub.textContent = this.copy[i < 2 ? 'coupon' : i === 2 ? 'discount' : 'gift'];
        group.append(sub);
      }
    }
    async api(action, details = {}) {
      if (!/^\/apps\/[a-zA-Z0-9/_-]+$/.test(this.dataset.endpoint)) throw new Error(this.copy.error);
      const signature = JSON.stringify(details);
      if (this.pending.get(action)?.signature !== signature) this.pending.set(action, { id: crypto.randomUUID(), signature });
      const response = await fetch(this.dataset.endpoint, { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ campaign: 'shipshop-pink-october-2026', action, requestId: this.pending.get(action).id, sessionToken: this.sessionToken || undefined, ...details }) });
      if (!response.ok) throw new Error(this.copy.error);
      const result = await response.json();
      return result;
    }
    async identify() {
      if (!this.emailForm.reportValidity()) return false;
      const email = normalizeEmail(this.querySelector('[data-email]').value);
      if (!email) throw new Error(this.copy.emailError);
      if (this.preview) {
        const digest = await crypto.subtle.digest('SHA-256', new TextEncoder().encode(email));
        this.previewKey = 'shipshop:wheel:october2026:preview:email-v1:' + Array.from(new Uint8Array(digest), value => value.toString(16).padStart(2, '0')).join('');
        try {
          const stored = localStorage.getItem(this.previewKey);
          let state = stored ? validState(JSON.parse(stored)) : initialState();
          if (state.finalized && !state.couponCode) state = this.issuePreview(state);
          localStorage.setItem(this.previewKey, JSON.stringify(state));
          this.state = state;
        } catch { throw new Error(this.copy.storageError); }
        this.identityReady = true;
        this.render();
        return this.state.attempts === 0;
      }
      this.spinButton.textContent = this.copy.emailBusy;
      const result = await this.api('start', { email });
      this.acceptIdentity(result);
      this.pending.delete('start');
      return this.state.attempts === 0;
    }
    acceptIdentity(result) {
      if (result.registered !== true || typeof result.sessionToken !== 'string' || !result.sessionToken || result.validated !== true) throw new Error(this.copy.error);
      this.state = validState(result.state);
      if (this.state.couponCode && !this.state.redeemPath) throw new Error(this.copy.error);
      this.sessionToken = result.sessionToken;
      this.identityReady = true;
      this.render();
    }
    issuePreview(state) {
      if (state.couponCode) return state;
      const issued = Date.now();
      return { ...state, finalized: true, couponCode: 'DEMO-PINK-' + crypto.randomUUID().replaceAll('-', '').slice(0, 20).toUpperCase(), issuedAt: new Date(issued).toISOString(), expiresAt: new Date(issued + couponLifetime).toISOString(), redeemPath: null };
    }
    savePreview(state) {
      try { localStorage.setItem(this.previewKey, JSON.stringify(state)); }
      catch { throw new Error(this.copy.storageError); }
    }
    async assignment() {
      const nextAttempt = this.state.attempts + 1;
      if (this.preview) {
        let state = { ...initialState(), attempts: nextAttempt, finalized: nextAttempt === 1, rewardId: ids[rewardForBucket(integer(100))], bonusWon: false };
        if (state.finalized) state = this.issuePreview(state);
        this.savePreview(state);
        return state;
      }
      const result = await this.api('spin', { nextAttempt });
      if (result.validated !== true) throw new Error(this.copy.error);
      const state = validState(result.state);
      if (state.attempts !== nextAttempt || (state.couponCode && !state.redeemPath)) throw new Error(this.copy.error);
      this.pending.delete('spin');
      return state;
    }
    async spin() {
      if (this.busy || this.state.finalized || this.state.attempts >= 1) return;
      this.busy = true;
      this.clearError();
      this.render();
      try {
        if (!this.identityReady && !(await this.identify())) return;
        this.spinButton.textContent = this.copy.spinning;
        const state = await this.assignment();
        const [start, end] = bounds[ids.indexOf(state.rewardId)];
        const landing = start + 8 + integer(Math.floor(end - start - 16));
        const target = (360 - landing) % 360;
        const current = ((this.rotation % 360) + 360) % 360;
        this.rotation += 360 * 5 + ((target - current + 360) % 360);
        const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.wheel.style.transform = `rotate(${reduce ? target : this.rotation}deg)`;
        if (!reduce) await new Promise(resolve => setTimeout(resolve, 3200));
        this.state = state;
        this.render();
        this.querySelector('[data-result]').scrollIntoView({ behavior: reduce ? 'instant' : 'smooth', block: 'nearest' });
      } catch (error) { this.showError(this.friendlyError(error)); }
      finally { this.busy = false; this.render(); }
    }
    async keep() {
      if (this.busy || !this.identityReady || this.state.attempts === 0 || (this.state.finalized && (this.preview || this.state.redeemPath))) return;
      this.busy = true;
      this.clearError();
      this.render();
      this.keepButton.textContent = this.copy.keeping;
      try {
        let state;
        if (this.preview) {
          state = this.issuePreview(this.state);
          this.savePreview(state);
        } else {
          const result = await this.api('finalize');
          if (result.validated !== true) throw new Error(this.copy.error);
          state = validState(result.state);
          if (!state.finalized || state.attempts !== this.state.attempts || state.rewardId !== this.state.rewardId || !state.redeemPath) throw new Error(this.copy.error);
          this.pending.delete('finalize');
        }
        this.state = state;
      } catch (error) { this.showError(this.friendlyError(error)); }
      finally { this.busy = false; this.render(); }
    }
  }
  if (!customElements.get('shipshop-pink-wheel')) customElements.define('shipshop-pink-wheel', ShipshopPinkWheel);
})();


  } catch(e) { console.error(e); }
})();
})();
